import React, {Component} from 'react'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend';
import {FormattedMessage, FormattedNumber} from 'react-intl'
import EventBus from '../common/EventBus.js'

class CustomerBalanceSummary extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            contactId: props.contactId,
            customerAccount: {},
        }

        this.refreshCustomerAccount = this.refreshCustomerAccount.bind(this)
        this.owingBalanceIsOverCreditLimit = this.owingBalanceIsOverCreditLimit.bind(this)
        this.updateSummary = this.updateSummary.bind(this)

        EventBus.listen(EventBus.TopicCustomerBalanceUpdate, 'customer-balance-summary', this.updateSummary)
    }

    updateSummary(updates) {
        this.refreshCustomerAccount()
    }

    componentDidMount() {
        this.refreshCustomerAccount()
    }

    componentWillReceiveProps(nextProps) {
        this.refreshCustomerAccount(nextProps.contactId)
    }

    refreshCustomerAccount(contactId) {
        if (!contactId) {
            contactId = this.state.contactId
        }
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }

            this.setState({
                customerAccount: res,
                contactId: contactId,
            })
        })
    }

    owingBalanceIsOverCreditLimit() {
        if (!this.state.customerAccount) {
            return false
        } else if (parseFloat(this.state.customerAccount.attributes.contact.attributes.creditLimit) === 0) {
            return false
        }

        return parseFloat(this.state.customerAccount.attributes.owingBalance) >
            parseFloat(this.state.customerAccount.attributes.contact.attributes.creditLimit)
    }

    render() {
        if (!this.state.customerAccount.attributes) {
            return ''
        }
        const customerAccount = this.state.customerAccount.attributes

        const owingLabel =
            <strong className="customer-info-label">
                <FormattedMessage
                    id="customers.customer_summary.amount_due_label"
                    defaultMessage="Amount Due :"
                />
            </strong>

        const owingAmount =
            <strong className={customerAccount.owingBalance > 0 ? "text-primary" : "text-secondary"}>
                <FormattedNumber
                    style="currency"
                    currency={customerAccount.owingBalanceCurrency}
                    value={customerAccount.owingBalance}
                />
            </strong>

        const creditLabel =
            <strong className="customer-info-label">
                <FormattedMessage
                    id="customers.invoices.list.credit_balance_label_no_amount"
                    defaultMessage="Credit:"
                />
            </strong>

        const creditAmount =
            <strong className={customerAccount.creditBalance > 0 ? "text-primary" : "text-secondary"}>
                <FormattedNumber
                    style="currency"
                    currency={customerAccount.creditBalanceCurrency || ''}
                    value={customerAccount.creditBalance || 0}
                />
            </strong>

        const totalBalanceLabelMessage =
            customerAccount.globalBalance < 0 ?
                <FormattedMessage
                    id="customers.customer_summary.owing_balance_label"
                    defaultMessage="Balance Owing:"
                /> :
                <FormattedMessage
                    id="customers.customer_summary.credit_available_label"
                    defaultMessage="Credit Available:"
                />
        const totalBalanceLabel =
            <strong className="customer-info-label">
                {totalBalanceLabelMessage}
            </strong>

        let owingBalanceBadge = "badge-primary"
        if (customerAccount.globalBalance < 0) {
            owingBalanceBadge = this.owingBalanceIsOverCreditLimit() ? "badge-danger" : "badge-warning"
        }
        const totalBalanceAmount =
            <strong className={"badge " + owingBalanceBadge}>
                <FormattedNumber
                    style="currency"
                    currency={customerAccount.creditBalanceCurrency || ''}
                    value={Math.abs(customerAccount.globalBalance) || 0}
                />
            </strong>

        const balanceRows =
            [
                [owingLabel, owingAmount, "owing"],
                [creditLabel, creditAmount, "credit"],
            ]

        return (
            <div>
                <h6 className="mt-4 mb-0 justify-self-center strong border-bottom pb-2 mb-2">Customer balance</h6>

                {
                    balanceRows.map(([label, amountLabel, rowName]) =>
                        <div key={rowName} className="row mb-1">
                            <span className="col-6 col-xl-5">
                                {label}
                            </span>

                            <span className="col-6 col-xl-4 pl-0 text-right">
                                {amountLabel}
                            </span>
                        </div>
                    )
                }

                <div className="row mb-1">
                    <span className="col-6 col-xl-5">
                        {totalBalanceLabel}
                    </span>

                    <h5 className="col-6 col-xl-4 pl-0 text-right mb-0 border-0 pb-0">
                        {totalBalanceAmount}
                    </h5>
                </div>
            </div>
        )
    }
}

export default CustomerBalanceSummary


// WEBPACK FOOTER //
// ./src/customer/customerbalancesummary.component.jsx